// helpers.ts — Pure utility functions for P251 PACKING LIST form

import { FP610, FP611 } from '../../services/p251Api';

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping */
export const fmt = (v: number | null | undefined, decimals = 2): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: decimals });
};

/** BR-C01: Recalculate a single detail row's computed fields */
export const recalcDetail = (
  row: Partial<FP611>,
  master: Partial<FP610>,
): Partial<FP611> => {
  const fp610_22 = master.fp610_22 || 0;  // MTS換算率
  const fp610_23 = master.fp610_23 || 0;  // 布重換算率
  const fp610_28 = master.fp610_28 || 0;  // 針織/平織

  // 四組碼數加總
  const fp611_41 = (row.fp611_21 || 0) + (row.fp611_22 || 0) + (row.fp611_23 || 0) + (row.fp611_24 || 0);

  // MTS = 換算率 × 合計碼數, ROUND至0位
  const fp611_42 = Math.round(fp610_22 * fp611_41);

  // G.W.: 針織(2)時 = 布重換算率 × (合計碼數 + 補碼數)
  let fp611_43 = row.fp611_43 || 0;
  if (fp610_28 === 2) {
    const supplementTotal = (row.fp611_51 || 0) + (row.fp611_52 || 0) + (row.fp611_53 || 0) + (row.fp611_54 || 0);
    fp611_43 = fp610_23 * (fp611_41 + supplementTotal);
  }

  // N.W. = ROUND(G.W. + 毛重變量, 1), G.W.為0時N.W.=0
  const fp611_44 = fp611_43 ? Math.round((fp611_43 + (row.fp611_442 || 0)) * 10) / 10 : 0;

  return {
    ...row,
    fp611_41,
    fp611_42,
    fp611_43,
    fp611_44,
  };
};

/** BR-C02: Recalculate master totals from all details */
export const recalcTotals = (
  details: Partial<FP611>[],
): Pick<FP610, 'fp610_16' | 'fp610_17' | 'fp610_18' | 'fp610_19' | 'fp610_20'> => {
  let total41 = 0;
  let total42 = 0;
  let total43 = 0;
  let total44 = 0;

  for (const d of details) {
    total41 += d.fp611_41 || 0;
    total42 += d.fp611_42 || 0;
    total43 += d.fp611_43 || 0;
    total44 += d.fp611_44 || 0;
  }

  return {
    fp610_16: details.length,
    fp610_17: total41,                                // 總碼數
    fp610_18: Math.round(total42 * 100) / 100,        // 總米數 ROUND(2)
    fp610_19: total43,                                // 總重量
    fp610_20: total44,                                // 總淨量
  };
};

/** Ship unit label */
export const getShipUnitLabel = (unit: number): string => {
  switch (unit) {
    case 1: return 'YDS';
    case 2: return 'MTS';
    case 3: return 'PCS';
    default: return '';
  }
};

/** Pack unit label */
export const getPackUnitLabel = (unit: number): string => {
  switch (unit) {
    case 1: return 'R/NO.';
    case 2: return 'B/NO.';
    case 3: return 'C/NO.';
    default: return '';
  }
};
